import MenuItem from "../Menu/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsOpenSidebar, useIsOpenSidebarAction } from "../../context/toggleSidebarContext";
import { useEffect, useState } from "react";
import data from "../../mockData/menu.json";
import Restricted from "../../context/Restricted";
import { logout } from "../../services";
import { useAuth } from "../../context/AuthContext";
import { useSweetAlert } from "../../context/sweetAlertContext";
import RulesModal from "../Modals/RulesModal";
import Modal from "../../components/Modal";

export default function Sidebar() {
    const [isOpenRules, setIsOpenRules] = useState(false);
    const [isOpenReferrerModal, setIsOpenReferrerModal] = useState(false);
    const [selectedParent, setSelectedParent] = useState(null);
    const { pages } = data;
    const setIsOpenSidebar = useIsOpenSidebarAction();
    const isOpenSidebar = useIsOpenSidebar();
    const route = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useAuth();
    const sweetAlert = useSweetAlert();

    const handleHoverSidebar = () => {
        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: true });
        }
    };

    const Logout = async () => {
        sweetAlert({
            show: true,
            title: "خروج از حساب کاربری",
            icon: 'warning',
            showCancelButton: true,
            text: `آیا میخواهید از حساب خود خارج شوید؟`,
            confirmButtonText: "تایید",
            cancelButtonText: "خیر",
            onConfirm: () => handleLogout(),
        });
    };

    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const { isSuccess } = await logout();
            if (isSuccess) {
                const html = document.querySelector('html');
                html.className = '';
                navigate('/login');
            }
            setIsLoading(false);
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setSelectedParent(route.pathname.split("/")[1]);
    }, [route.pathname]);

    const handleBlurSidebar = () => {
        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: false });
        }
    };

    useEffect(() => {
        if (isOpenSidebar.collapsed) {
            if (isOpenSidebar.expanded) {
                setIsOpenSidebar({ ...isOpenSidebar, expanded: false });
            }
        }
    }, [route.pathname]);

    const userData = user?.userInfo?.data;

    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme"
            onMouseEnter={handleHoverSidebar} onMouseLeave={handleBlurSidebar}>
            <div className="app-brand demo">
                <button className="layout-menu-toggle bg-transparent border-0 menu-link text-large ms-auto">
                    <i className="bx menu-toggle-icon d-none d-xl-block fs-4 align-middle"
                        onClick={() => setIsOpenSidebar({ ...isOpenSidebar, collapsed: !isOpenSidebar.collapsed })} />
                    <i className="bx bx-x d-block d-xl-none bx-sm align-middle"
                        onClick={() => setIsOpenSidebar({ ...isOpenSidebar, expanded: false })} />
                </button>
            </div>
            <div className="menu-divider mt-0" />

            <div className="menu-inner-shadow" />
            <div className="user-profile mb-2">
                <img src="/icons/user.png" alt="User Profile" />
            </div>
            
            <div className="user-info text-center px-2 d-flex flex-column gap-1">
                {/* نام و نام خانوادگی (سفید) */}
                <h6 className="user-name text-white mb-0 font-14 fw-bold">
                    {userData
                        ? `${userData.firstName || ""} ${userData.lastName || ""}`.trim() || "—"
                        : "—"}
                </h6>

                {/* شماره موبایل ساده و خوانا (سفید) */}
                <div className="text-white font-13" dir="ltr">
                    {userData?.mobile || "—"}
                </div>

                {/* کد دعوت (سفید) */}
                <div className="user-reference-code font-13 text-white mb-1">
                    <span>کد دعوت شما: </span>
                    <strong className="text-white fw-bold">{userData?.referenceCode || "—"}</strong>
                </div>

                {/* دکمه اطلاعات معرف با های‌لایت آبی کم‌رنگ و متن مشکی */}
                <div className="mt-1">
                    <button
                        type="button"
                        onClick={() => setIsOpenReferrerModal(true)}
                        className="btn btn-sm px-3 py-1 font-12 rounded-pill border-0"
                        style={{
                            backgroundColor: '#e8f0fe',
                            color: '#000000',
                            fontWeight: '600',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                        }}
                    >
                        اطلاعات معرف شما
                    </button>
                </div>
            </div>

            <ul className="menu-inner py-1">
                {pages && pages.length > 0 && pages.map(item => (
                    <Restricted to={item?.permission || ""} key={item.id}>
                        <MenuItem item={item} onClick={setSelectedParent} selectedParent={selectedParent} />
                    </Restricted>
                ))}
                <li className="menu-item menu-item-animating">
                    <button className="menu-link w-100 border-0 text-danger bg-transparent" onClick={() => Logout()}>
                        <i className="menu-icon tf-icons bx bx-log-out text-danger" />
                        <div>خروج از حساب کاربری</div>
                    </button>
                    <button
                        className="menu-link w-100 border-0 text-primary mb-1 bg-transparent"
                        onClick={() => setIsOpenRules(true)}
                    >
                        <i className="menu-icon tf-icons bx bx-file-text" />
                        <div>قوانین و مقررات</div>
                    </button>
                    <p className="text-center font-11 mt-2 text-muted">App Version: {process.env.REACT_APP_VERSION}</p>
                </li>
            </ul>

            <RulesModal isOpen={isOpenRules} setIsOpen={setIsOpenRules} />

            {/* مودال اطلاعات معرف */}
            {isOpenReferrerModal && (
                <Modal
                    isOpen={isOpenReferrerModal}
                    onClose={() => setIsOpenReferrerModal(false)}
                    size="md"
                >
                    <div className="p-3 text-dark" dir="rtl">
                        {/* هدر */}
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                            <h5 className="font-16 fw-bold mb-0">اطلاعات معرف شما</h5>
                        </div>

                        {/* بدنه محتوا */}
                        <div className="text-start py-2 lh-lg">
                            {/* نام و نام خانوادگی */}
                            <div className="mb-2">
                                <span className="fw-semibold text-muted">نام و نام خانوادگی: </span>
                                <span className="fw-bold">
                                    {`${userData?.referencerFirstName || ""} ${userData?.referencerLastName || ""}`.trim() || "—"}
                                </span>
                            </div>

                            {/* کد معرف */}
                            <div className="d-flex align-items-center flex-wrap gap-2 pt-1">
                                <span className="fw-semibold text-muted">کد دعوت معرف شما:</span>
                                <span className="badge bg-label-primary fs-6 px-2 py-1">
                                    {userData?.referencerReferenceCode || "—"}
                                </span>
                            </div>
                        </div>

                        {/* فوتر */}
                        <div className="border-top pt-3 mt-3 text-end">
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm px-4"
                                onClick={() => setIsOpenReferrerModal(false)}
                            >
                                بستن
                            </button>
                        </div>
                    </div>
                </Modal>
            )}

        </aside>
    );
}
